module.exports = __webpack_public_path__ + "static/loading.573c1bbf.gif";